export default __webpack_public_path__ + "static/media/search_no_record.39cd7a96.png";